import request from '@/utils/request'
import qs from 'qs'

// 获取消息列表
export const getInformList = (params) => {
  return request({
    url: '/api/message',
    method: 'GET',
    params: params,
    paramsSerializer: params => {
      return qs.stringify(params, {indices: false})
    }
  })
  
}
export const getInformListSmall = (type) => {
    return request({
      url: '/api/message/lightweight/' + type,
      method: 'GET',
    })
}

//获取换版详情
export const getMessageStandard = (id) => {
    return request({
      url: '/api/message/standardReplace/' + id,
      method: 'GET'
    })
}
// 获取变更详情（将消息设置为已读）
export const getMessageChange = (id) => {
    return request({
      url: '/api/message/warning/' + id,
      method: 'GET'
    })
}
// 将用户的所有消息设置为已读
export const putMessageReady = (type) => {
    return request({
      url: `/api/message/readAll/${type}`,
      method: 'PUT'
    })
}

export const putMessageReadyTop = () => {
  return request({
    url: '/api/message/lightweight/readAll',
    method: 'PUT'
  })
}
// 删除消息
export const deleteMessage = (params) => {
    return request({
      url: '/api/message',
      method: 'PUT',
      data: params
    })
}

export const lookMessageStatus = () => {
    return request({
      url: '/api/message/type',
      method: 'GET'
    })
}
//选择公司
export const selectSmallCompany = () =>{
  return request({
    url:'/api/messageCompany',
    method: 'GET'
  })
}